// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import ExportToExcel from '../../../shared/state/export-to-excel';
import OpenPartsReturnsFacets from './open-part-returns-facets';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnListWrapper from '../components/part-return-list-wrapper';
import PartReturnsWrapper from '../../shared/components/part-returns-wrapper';
import SearchFilters from '../state/search-filters';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class OpenPartRequests extends Component {

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    getFacets() {

        return (
            <OpenPartsReturnsFacets
                actions={this.props.actions}
                facets={this.props.facets}
            />
        );

    }

    render() {

        return (
            <PartReturnsWrapper
                actions={this.props.actions}
                allPartRequestsCount={this.props.allPartReturnsCount}
                facets={this.getFacets()}
                hasSearchResultsLoaded={this.props.hasSearchResultsLoaded}
                openPartRequestsCount={this.props.openPartReturns.length}
                searchByDropdown={this.props.searchByDropdown}
                searchQueryString={this.props.searchQueryString}
                searchResultsCount={this.props.searchResultsCount}
            >
                <PartReturnListWrapper
                    actions={this.props.actions}
                    busyCounter={this.props.busyCounter}
                    exportToExcel={this.props.exportToExcel}
                    facets={this.getFacets()}
                    openPartRequestsCount={this.props.openPartReturns.length}
                    partReturns={this.props.openPartReturns}
                    searchFilters={this.props.searchFilters}
                    searchQueryString={this.props.searchQueryString}
                    searchResultsCount={this.props.searchResultsCount}
                />
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
            </PartReturnsWrapper>
        );

    }

}

OpenPartRequests.displayName = 'OpenPartRequests';
OpenPartRequests.propTypes = {
    actions: PropTypes.object.isRequired,
    allPartReturnsCount: PropTypes.number.isRequired,
    busyCounter: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.object.isRequired,
    hasSearchResultsLoaded: PropTypes.bool.isRequired,
    openPartReturns: PropTypes.arrayOf(PropTypes.instanceOf(PartReturn)).isRequired,
    searchByDropdown: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired
};
export default OpenPartRequests;



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/components/open-part-requests.js